import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiArrowRight, FiCheckCircle } = FiIcons;

const AboutStory = () => {
  const { lang } = useLanguage();
  const isSpanish = lang === 'es';

  const lessons = isSpanish
    ? [
        'Las ventas me enseñaron cómo compra la gente.',
        'El contenido me enseñó a ganarme la atención.',
        'El diseño instruccional me enseñó a comunicar con claridad.',
        'La IA me enseñó a automatizar lo que ocurre después.'
      ]
    : [
        'Sales taught me how people buy.',
        'Content taught me how to earn attention.',
        'Instructional Design taught me how to communicate clearly.',
        'AI taught me how to automate what happens next.'
      ];

  return (
    <section className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-28">
      <div className="lg:col-span-5">
        <p className="text-orange-500 font-black text-xs tracking-[0.24em] uppercase mb-5">
          {isSpanish ? 'El recorrido' : 'The background'}
        </p>
        <h2 className="text-4xl md:text-5xl font-black tracking-tighter text-white leading-[0.95]">
          {isSpanish
            ? 'De vender a construir sistemas.'
            : 'From selling to building systems.'}
        </h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="lg:col-span-7 space-y-6 text-zinc-400 text-lg leading-relaxed"
      >
        <p>
          {isSpanish
            ? 'Durante años, mi trabajo fue sencillo: entender al cliente, encontrar el problema, comunicar el valor y cerrar la venta.'
            : 'For years, my job was simple: understand the customer, find the problem, communicate the value and close the deal.'}
        </p>
        <p>
          {isSpanish
            ? 'Cuando pasé al diseño instruccional, empecé a hacer algo diferente: tomar información compleja y convertirla en algo que la gente pudiera entender y poner en práctica fácilmente.'
            : 'When I moved into Instructional Design, I started doing something different: taking complex information and turning it into something people can easily understand and act on.'}
        </p>
        <p>
          {isSpanish
            ? 'Y después de años haciendo fotografía y vídeo, aprendí cuánta confianza puede generar una buena comunicación visual. Con el tiempo, estos tres mundos se unieron.'
            : 'Through years of photography and video production, I learned how much trust can be created through good visual communication. Eventually, these three worlds came together.'}
        </p>

        <div className="mt-10 space-y-4">
          {lessons.map((lesson) => (
            <div
              key={lesson}
              className="flex gap-4 items-start p-5 bg-zinc-900/70 border border-white/5 rounded-2xl"
            >
              <SafeIcon
                icon={FiCheckCircle}
                className="text-orange-500 text-xl mt-0.5 shrink-0"
              />
              <p className="text-white font-bold">{lesson}</p>
            </div>
          ))}
        </div>

        <p className="pt-4 text-white text-xl font-bold">
          {isSpanish
            ? 'Eso es lo que aporto a tu negocio.'
            : 'That is what I bring to your business.'}
          <SafeIcon icon={FiArrowRight} className="inline ml-3 text-orange-500" />
        </p>
      </motion.div>
    </section>
  );
};

export default AboutStory;